export enum TWType {
  normal = "normal",
  mm = "mm",
}
